import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import getConsumerMailboxOptions from '../services/getConsumerMailboxOptions';
import getCASMailboxOptions from '../services/getCASMailboxOptions';
import { isConsumer } from 'owa-session-store';

export default action('initPopImapConfiguration')(async function initPopImapConfiguration() {
    if (store.popEnabled) {
        // If we already have the PopImap configuration, we won't get it again
        return;
    }

    let casMailboxOptions = await getCASMailboxOptions();
    store.popSettings = casMailboxOptions.ExternalPopSettings;
    store.imapSettings = casMailboxOptions.ExternalImapSettings;
    store.smtpSettings = casMailboxOptions.ExternalSmtpSettings;

    if (isConsumer()) {
        let consumerMailboxOptions = await getConsumerMailboxOptions();
        store.popEnabled = consumerMailboxOptions.PopEnabled;
        store.popMessageDeleteEnabled = consumerMailboxOptions.PopMessageDeleteEnabled;
    } else {
        store.popEnabled = casMailboxOptions.PopEnabled;
    }
});
